import * as url from "../url_helper";

import { post } from "../api_helper";

export const addApiConfiguration = data => post(url.ADD_API_CONFIGURATION, data);

export const getApiConfiguration = data => post(url.GET_API_CONFIGURATION, data);

export const editApiConfiguration = data => post(url.EDIT_API_CONFIGURATION, data);

export const getApiConfigurationById = data => post(url.GET_API_CONFIGURATION_BY_ID, data);